import * as React from "react"
import {DropdownProps, Form, Input, InputOnChangeData, Select} from "semantic-ui-react"
import {AirlineFragment, AirportAirlines, FlightTypeEnum} from "../graphql/queries"
import {assertString} from "../tsutil"
import {ID} from "../model/id"
import {BookingFormAirportState} from "../state"
import {MapState} from "./BookingDetails"
import {updateAirportStop} from "../reducers"
import {GraphQL} from "../graphql"

type AirportAirlines = Array<AirlineFragment>

interface AirlineSelectionProps {
  airportAirlines: AirportAirlines | null
  value: string
  onChange: (e: React.SyntheticEvent<HTMLElement>, field: DropdownProps) => void
  disabled: boolean
}

function AirlineSelection(props: AirlineSelectionProps) {
  const {airportAirlines} = props

  const options = (airportAirlines || []).map((airline) => ({
    value: airline.id,
    text: `${airline.name} (${airline.id})`,
  }))

  return (
    <Select
      search
      name="airlineCode"
      value={props.value}
      options={options}
      onChange={props.onChange}
      disabled={props.disabled}
      loading={airportAirlines === null}
    />
  )
}

export function emptyAirportState(): BookingFormAirportState {
  return {
    airlineCode: "QF",
    flightType: FlightTypeEnum.Domestic,
    flightNumber: "",
  }
}

interface PickupTypeSelectionProps {
  value: FlightTypeEnum
  onChange: (e: React.SyntheticEvent<HTMLElement>, field: DropdownProps) => void
  disabled: boolean
}

// TODO FlightTypeEnum is a graphql enum but a typescript type and we can't enumerate it...
const flightTypeOptions = [
  {value: "Domestic", text: "Domestic"},
  {value: "International", text: "International"},
]

function FlightTypeSelection(props: PickupTypeSelectionProps) {
  return (
    <Select
      placeholder="Flight type"
      name="flightType"
      value={props.value}
      options={flightTypeOptions}
      onChange={props.onChange}
      disabled={props.disabled}
    />
  )
}

interface OwnProps {
  state: BookingFormAirportState
  mapState: MapState<BookingFormAirportState> | null
  flightNumberRequired: boolean
  wantFlightNumber: boolean
  airportPlaceId: ID
  disabled: boolean
}

interface QueryProps {
  loading?: boolean
  airportAirlines: AirportAirlines | null
}

type FieldWithStringValue = DropdownProps | InputOnChangeData

type Props = OwnProps & QueryProps

function AirportStopForm(props: Props) {
  const {mapState} = props
  const onFieldChange = mapState && makeOnFieldChange(mapState)
  const {airportAirlines, state, wantFlightNumber, flightNumberRequired, disabled} = props

  const view = !mapState

  const someFlightNumber = state.flightNumber !== ""
  const flightNumberField = wantFlightNumber && (!view || flightNumberRequired || someFlightNumber)

  return (
    <>
      <Form.Group>
        <Form.Field required>
          <label>Airline</label>
          {!onFieldChange ? (
            <div>{state.airlineCode}</div>
          ) : (
            <AirlineSelection
              airportAirlines={airportAirlines}
              value={state.airlineCode!}
              onChange={onFieldChange}
              disabled={disabled}
            />
          )}
        </Form.Field>
        <Form.Field>
          <label>Flight type</label>
          {!onFieldChange ? (
            <div>{state.flightType}</div>
          ) : (
            <FlightTypeSelection
              value={state.flightType!}
              onChange={onFieldChange}
              disabled={disabled}
            />
          )}
        </Form.Field>
      </Form.Group>
      {flightNumberField && (
        <Form.Group>
          <Form.Field required={flightNumberRequired}>
            <label>Flight number</label>
            {!onFieldChange ? (
              <div>{state.flightNumber}</div>
            ) : (
              <Input
                placeholder="Flight number"
                name="flightNumber"
                type="number"
                pattern="\d*"
                value={state.flightNumber}
                onChange={onFieldChange}
                disabled={disabled}
              />
            )}
          </Form.Field>
        </Form.Group>
      )}
    </>
  )
}

function WithGraphQL(props: OwnProps) {
  const {airportPlaceId} = props
  return (
    <GraphQL.Query
      query={AirportAirlines}
      variables={{airportPlaceId}}
      render={({data}) => {
        return <AirportStopForm {...props} airportAirlines={data && data.airportAirlines} />
      }}
    />
  )
}

function makeOnFieldChange(mapState: MapState<BookingFormAirportState>) {
  return (e: React.SyntheticEvent<HTMLElement>, field: FieldWithStringValue) => {
    mapState((state) => {
      return updateAirportStop(state, field.name, assertString(field.value))
    })
  }
}

export {WithGraphQL as AirportStopForm}



// WEBPACK FOOTER //
// ./src/components/AirportStop.tsx